import React, { useEffect, useState } from 'react';
import { api, apiError } from '../../lib/api';

export default function AdminCities() {
  const [cities, setCities] = useState([]);
  const [f, setF] = useState({ name:'', state:'', country:'India' });
  const [err, setErr] = useState('');

  const load = async () => { const { data } = await api.get('/cities'); setCities(data.cities||[]); };
  useEffect(() => { load(); }, []);

  const add = async (e) => {
    e.preventDefault(); setErr('');
    try { await api.post('/admin/cities', f); setF({ name:'',state:'',country:'India' }); await load(); }
    catch (e) { setErr(apiError(e)); }
  };
  const del = async (c) => { if(window.confirm('Delete city?')) { await api.delete(`/admin/cities/${c.id}`); await load(); } };

  return (
    <div data-testid="admin-cities">
      <h2 className="mb-3">Cities</h2>
      {err && <div className="alert alert-danger">{err}</div>}
      <div className="ap-card mb-3">
        <form onSubmit={add} className="d-flex gap-2 flex-wrap" data-testid="add-city-form">
          <input className="form-control" placeholder="City name" required value={f.name} onChange={e=>setF({...f,name:e.target.value})} style={{maxWidth:220}} data-testid="city-name"/>
          <input className="form-control" placeholder="State" value={f.state} onChange={e=>setF({...f,state:e.target.value})} style={{maxWidth:200}} data-testid="city-state"/>
          <input className="form-control" placeholder="Country" value={f.country} onChange={e=>setF({...f,country:e.target.value})} style={{maxWidth:180}} data-testid="city-country"/>
          <button className="btn-ap" data-testid="city-add-btn">Add city</button>
        </form>
      </div>
      <div className="ap-card p-0 overflow-auto">
        <table className="ap-table">
          <thead><tr><th>Name</th><th>State</th><th>Country</th><th></th></tr></thead>
          <tbody>
            {cities.map(c => (
              <tr key={c.id} data-testid={`city-row-${c.id}`}>
                <td>{c.name}</td><td>{c.state}</td><td>{c.country}</td>
                <td><button className="btn btn-sm text-danger" onClick={()=>del(c)} data-testid={`del-city-${c.id}`}>Delete</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
